module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "clum2right right"
  }, [_c('div', {
    staticClass: "right",
    attrs: {
      "id": "content_block"
    }
  }, [_c('div', {
    staticClass: "content_icon right"
  }), _vm._v(" "), _c('div', {
    staticClass: "content_title right"
  }, [_vm._v("چگونه بروزرسانی نمایید؟")]), _vm._v(" "), _c('div', {
    staticClass: "right",
    attrs: {
      "id": "content_main"
    }
  }, [_c('ul', [_c('li', [_c('img', {
    attrs: {
      "src": require("../../assets/images/step-01.png"),
      "width": "140",
      "height": "160",
      "alt": ""
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "setpfonts"
  }, [_vm._v("ثبت نام یک حساب کاربری")])]), _vm._v(" "), _c('li', [_c('img', {
    attrs: {
      "src": require("../../assets/images/step-arrow.png"),
      "width": "30",
      "height": "160",
      "alt": ""
    }
  })]), _vm._v(" "), _c('li', [_c('img', {
    attrs: {
      "src": require("../../assets/images/step-02.png"),
      "width": "140",
      "height": "160",
      "alt": ""
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "setpfonts"
  }, [_vm._v("دانلود ابراز بروزرسانی شده و نصب بر روی کامپیوتر")])]), _vm._v(" "), _c('li', [_c('img', {
    attrs: {
      "src": require("../../assets/images/step-arrow.png"),
      "width": "30",
      "height": "160",
      "alt": ""
    }
  })]), _vm._v(" "), _c('li', [_c('img', {
    attrs: {
      "src": require("../../assets/images/step-03.png"),
      "width": "140",
      "height": "160",
      "alt": ""
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "setpfonts"
  }, [_vm._v("ورود به ابزار بروزرسانی و دانلود نقشه ها")])]), _vm._v(" "), _c('li', [_c('img', {
    attrs: {
      "src": require("../../assets/images/step-arrow.png"),
      "width": "30",
      "height": "160",
      "alt": ""
    }
  })]), _vm._v(" "), _c('li', [_c('img', {
    attrs: {
      "src": require("../../assets/images/step-04.png"),
      "width": "140",
      "height": "160",
      "alt": ""
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "setpfonts"
  }, [_vm._v("نصب بروزرسانی")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "right spcacetop",
    attrs: {
      "id": "content_block"
    }
  }, [_c('div', {
    staticClass: "content_icon right"
  }), _vm._v(" "), _c('div', {
    staticClass: "content_title right"
  }, [_vm._v("FAQ")]), _vm._v(" "), _c('div', {
    staticClass: "right",
    attrs: {
      "id": "qandalist"
    }
  }, [_c('ol', [_c('li', [_c('div', {
    staticClass: "titel3"
  }, [_vm._v("بروزرسانی نقشه مسیریاب شما")]), _vm._v(" "), _c('div', {
    staticClass: "con3"
  }, [_vm._v("در اينجا بخوانيد كه چگونه آخرين ورژن نقشه را روى دستگاه مسيرياب خود بروزرسانى نماييد."), _c('br')]), _vm._v(" "), _c('div', {
    staticClass: "btn3"
  }, [_c('button', {
    staticClass: "button-warning pure-button pure-button-primary login_input",
    attrs: {
      "onclick": "window.open('http://maptool.polnav.com.tw/manual/Motrex_FAR-1.pdf','_blank')"
    }
  }, [_vm._v("اینجا را کلیک نمایید")])])]), _vm._v(" "), _c('li', [_c('div', {
    staticClass: "titel3"
  }, [_vm._v(" نصب ابزار بروز رسانی نقشه ")]), _vm._v(" "), _c('div', {
    staticClass: "con3"
  }, [_vm._v("در اينجا بخوانيد كه چگونه نرم افزار Map updater 3 را جهت بروزرسانى آخرين نسخه نقشه، نصب نماييد.")]), _vm._v(" "), _c('div', {
    staticClass: "btn3"
  }, [_c('button', {
    staticClass: "button-warning pure-button pure-button-primary login_input",
    attrs: {
      "onclick": "window.open('http://maptool.polnav.com.tw/manual/Motrex_FAR-2.pdf','_blank')"
    }
  }, [_vm._v("اینجا را کلیک نمایید")])])]), _vm._v(" "), _c('li', [_c('div', {
    staticClass: "titel3"
  }, [_vm._v("خریداری یا دانلود فایل های بروزرسانی")]), _vm._v(" "), _c('div', {
    staticClass: "con3"
  }, [_vm._v("در اینجا بخوانید که چگونه آخرین نسخه نقشه را خریداری یا دانلود نمایید. "), _c('br')]), _vm._v(" "), _c('div', {
    staticClass: "btn3"
  }, [_c('button', {
    staticClass: "button-warning pure-button pure-button-primary login_input",
    attrs: {
      "onclick": "window.open('http://maptool.polnav.com.tw/manual/Motrex_FAR-3.pdf','_blank')"
    }
  }, [_vm._v("اینجا را کلیک نمایید")])])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-40e0bde4!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/public/LoginContent.vue
// module id = 104
// module chunks = 1